<template>
  <div id="app">
    <nav class="nav-menu">
      <router-link to="/breath" class="nav-item">呼吸训练</router-link>
      <router-link to="/neck" class="nav-item">颈部训练</router-link>
    </nav>
    <router-view></router-view>
    <footer class="icp-footer">
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
        渝ICP备2023014603号-1
      </a>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

html {
  font-size: 16px;
}

@media screen and (max-width: 768px) {
  html {
    font-size: 14px;
  }
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #f5f7fa;
  line-height: 1.6;
}

#app {
  max-width: 100%;
  min-height: 100vh;
  padding: 0;
}

.nav-menu {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: white;
  display: flex;
  justify-content: space-around;
  padding: 0.8rem 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  border-bottom: 1px solid #e0e0e0;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: #666;
  font-size: 0.8rem;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  transition: all 0.3s ease;
  position: relative;
}

.nav-item:hover {
  background: #f5f5f5;
}

.nav-item.router-link-active {
  color: #4CAF50;
  font-weight: 600;
}

.nav-item.router-link-active::after {
  content: '';
  position: absolute;
  bottom: -0.8rem;
  left: 50%;
  transform: translateX(-50%);
  width: 4px;
  height: 4px;
  background-color: #4CAF50;
  border-radius: 50%;
}

.nav-item i {
  font-size: 1.4rem;
  margin-bottom: 0.3rem;
  transition: transform 0.3s ease;
}

.nav-item.router-link-active i {
  transform: scale(1.1);
}

@media screen and (max-width: 480px) {
  .nav-item {
    font-size: 0.75rem;
    padding: 0.4rem 0.8rem;
  }

  .nav-item i {
    font-size: 1.3rem;
  }
}

/* 通用按钮样式 */
button {
  border: none;
  border-radius: 2rem;
  padding: 0.8rem 1.5rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: #f0f0f0;
  color: #2c3e50;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

button:active {
  transform: scale(0.98);
}

button.active {
  background-color: #4CAF50;
  color: white;
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3);
}

/* 通用卡片样式 */
.card {
  background: white;
  border-radius: 1rem;
  padding: 1.5rem;
  margin: 1rem 0;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

/* 通用标题样式 */
h1 {
  font-size: 1.8rem;
  margin-bottom: 1.5rem;
  color: #2c3e50;
  text-align: center;
}

h2 {
  font-size: 1.4rem;
  margin-bottom: 1rem;
  color: #2c3e50;
}

h3 {
  font-size: 1.2rem;
  margin-bottom: 0.8rem;
  color: #2c3e50;
}

/* 通用动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-enter-active {
  animation: fadeIn 0.3s ease;
}

/* 通用响应式容器 */
.container {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 1rem;
  padding-top: 4rem; /* 为顶部导航留出空间 */
  padding-bottom: 3rem; /* 为底部ICP备案号留出空间 */
}

/* 通用警告框样式 */
.warning-box {
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  border-radius: 1rem;
  padding: 1rem;
  margin: 1rem 0;
  text-align: left;
}

.warning-box h3 {
  color: #856404;
  margin-top: 0;
}

.warning-box ul {
  margin: 0.5rem 0;
  padding-left: 1.5rem;
}

.warning-box li {
  color: #666;
  margin: 0.3rem 0;
}

/* ICP备案号样式 */
.icp-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  padding: 0.5rem;
  background-color: rgba(255, 255, 255, 0.9);
  font-size: 0.8rem;
  color: #666;
  z-index: 1000;
  border-top: 1px solid #e0e0e0;
}

.icp-footer a {
  color: #666;
  text-decoration: none;
  transition: color 0.3s ease;
}

.icp-footer a:hover {
  color: #4CAF50;
}
</style> 